"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetVideo ($videoId: String!) {\n    getVideo (videoId: $videoId){\n      videoId\n      name\n      updatedAt\n      assetIds\n      brandId\n      targetAudience\n      creativeInput\n      notesToTheEditor\n      keyMessage\n      callToAction\n      organisationId\n      musicStyle\n      videoStyle\n      createdByUserId\n      permissions\n      clips {\n        clipId\n        assetId\n      }\n      presenters {\n        presenterId\n        name\n        title\n        description\n        imageKey\n      }\n      collaborators {\n        resourceRoleAssignmentId\n        role {\n          roleId\n          name\n        }\n        user {\n          userId\n          firstName\n          lastName\n          imageUrl\n          phoneNumber\n          email\n        }\n      }\n      outputs {\n        outputId\n        readableId\n        name\n        aspectRatio\n        latestVersion\n        status {\n          name\n        }\n        isMaster\n        assignedEditorId\n        difficulty\n        videoId\n        onHoldDate\n        versions {\n          versionId\n          versionNumber\n          dueDate\n          submittedAt\n          assetId\n          clientRejectionReasons\n          appliedAddons {\n            BURN_IN_CAPTIONS {\n              value\n            }\n            SRT_CAPTIONS {\n              value\n            }\n            GREEN_SCREEN {\n              status\n            }\n            CHROMA_KEY {\n              value\n            }\n            RUSH_EDIT {\n              value\n            }\n            DURATION {\n              value\n            }\n          }\n          requestedAddons {\n            BURN_IN_CAPTIONS {\n              value\n            }\n            SRT_CAPTIONS {\n              value\n            }\n            GREEN_SCREEN {\n              status\n            }\n            CHROMA_KEY {\n              status\n            }\n            RUSH_EDIT {\n              value\n            }\n            DURATION {\n              value\n            }\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getVideoQuery = (0, _graphqlTag.default)(_templateObject());

var getVideo = function getVideo(videoId) {
  return {
    query: getVideoQuery,
    module: 'video',
    ignoreCache: true,
    buildVariables: function buildVariables() {
      return {
        videoId: videoId
      };
    }
  };
};

var _default = getVideo;
exports.default = _default;